import { Editor } from "@tiptap/react";
import { MarkdownFeature } from "./MarkdownEditor";

interface MarkdownToolbarProps {
  editor: Editor;
  features: MarkdownFeature[];
  onSwitchMode: () => void;
}

export const MarkdownToolbar = ({
  editor,
  features,
  onSwitchMode,
}: MarkdownToolbarProps) => {
  const ToolbarButton = ({
    onClick,
    isActive = false,
    children,
    title,
  }: {
    onClick: () => void;
    isActive?: boolean;
    children: React.ReactNode;
    title: string;
  }) => (
    <button
      type="button"
      onClick={onClick}
      className={`markdown-toolbar__button ${isActive ? "active" : ""}`}
      title={title}
    >
      {children}
    </button>
  );

  return (
    <div className="markdown-toolbar">
      <div className="markdown-toolbar__buttons">
        {features.includes("bold") && (
          <ToolbarButton
            onClick={() => editor.chain().focus().toggleBold().run()}
            isActive={editor.isActive("bold")}
            title="Bold"
          >
            <strong>B</strong>
          </ToolbarButton>
        )}
        {features.includes("italic") && (
          <ToolbarButton
            onClick={() => editor.chain().focus().toggleItalic().run()}
            isActive={editor.isActive("italic")}
            title="Italic"
          >
            <em>I</em>
          </ToolbarButton>
        )}
        {features.includes("code") && (
          <ToolbarButton
            onClick={() => editor.chain().focus().toggleCode().run()}
            isActive={editor.isActive("code")}
            title="Code"
          >
            &lt;&gt;
          </ToolbarButton>
        )}
        {features.includes("link") && (
          <ToolbarButton
            onClick={() => {
              const url = window.prompt("URL");
              if (url) {
                editor.chain().focus().setLink({ href: url }).run();
              }
            }}
            isActive={editor.isActive("link")}
            title="Link"
          >
            🔗
          </ToolbarButton>
        )}
        {features.includes("heading") && (
          <ToolbarButton
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 2 }).run()
            }
            isActive={editor.isActive("heading")}
            title="Heading"
          >
            H
          </ToolbarButton>
        )}
        {features.includes("blockquote") && (
          <ToolbarButton
            onClick={() => editor.chain().focus().toggleBlockquote().run()}
            isActive={editor.isActive("blockquote")}
            title="Quote"
          >
            &quot;&quot;
          </ToolbarButton>
        )}
        {features.includes("bulletList") && (
          <ToolbarButton
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            isActive={editor.isActive("bulletList")}
            title="Bullet List"
          >
            •
          </ToolbarButton>
        )}
        {features.includes("orderedList") && (
          <ToolbarButton
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
            isActive={editor.isActive("orderedList")}
            title="Numbered List"
          >
            1.
          </ToolbarButton>
        )}
      </div>

      <button
        type="button"
        className="markdown-toolbar__switch-link"
        onClick={onSwitchMode}
      >
        Switch to Markdown
      </button>
    </div>
  );
};
